"use strict";

define('components/filter_bar/table/bulk_send_electronic_delivery_consent',['components/ajax'], function(ajax) {
    var bulkSendElectronicDeliveryConsentComponent = {
        initWithContext: function(context) {
            var tableObjectType = context.tableFilterBarData.tableObjectType;

            // For accounts only
            if (tableObjectType != 6) return;

            // Click handler for the electronic-delivery-consent button
            var sendButton = context.buttonbarNode.find('.selection-consent button:not(.disabled)');
            sendButton.click(function() {
                var objectIds = context.tableFilterBarData.tableInstance.getSelectedObjectIds();

                var formData = new FormData();
                formData.append('object_ids', JSON.stringify(objectIds));
                formData.append('email_template', 'electronic_delivery_consent');

                ajax('/email_batch/add/' + tableObjectType, {
                    formData: formData
                });
            });
        }
    };

    return bulkSendElectronicDeliveryConsentComponent;
});
